import Modal from "react-modal";
import StyledModal from "../../common/Modal/StyledModal";
import { ReactComponent as ArrowNextWhite } from "../../../assets/icons/arrowNextWhite.svg";
import { ReactComponent as Success } from "../../../assets/icons/Success.svg";

const SuccessModal = ({
  displaySuccessModal,
  customStyles,
  closeSuccessModal,
}) => (
  <StyledModal>
    <Modal
      isOpen={displaySuccessModal}
      style={customStyles}
      contentLabel="Quit Modal"
      overlayClassName="overlay-modal"
      shouldCloseOnOverlayClick={false} // add this to prevent outside click to prevent modal close
    >
      <div className="wrapper-modal">
        <div className="image">
          <Success />
        </div>
        <div className="main-text">Success</div>
        <div className="second-text">
          Your order has been sent to the nominated drug distributor. Click
          below to return to the home screen
        </div>
      </div>
      <div className="wrapper-buttons">
        <button className="green-button" onClick={closeSuccessModal}>
          Home <ArrowNextWhite />
        </button>
      </div>
    </Modal>
  </StyledModal>
);
export default SuccessModal;
